import React from 'react';
import DefaultLayout from '../../../layouts/default';

// Import local sub-components from the components folder directory
import AllergenHeader from './components/AllergenHeader';
import AllergenChecklist from './components/AllergenChecklist';
import CheckProgress from './components/CheckProgress';
import ComplianceRecords from './components/ComplianceRecords';
import GuidanceAndImportantCards from './components/GuidanceAndImportantCards';
import AllergenSignOff from './components/AllergenSignOff';

function MonthlyAlerginCheckPage() {
  return (
    <DefaultLayout>
        <div className="w-full bg-slate-50/50 min-h-screen p-4 md:p-6 space-y-6 font-sans antialiased selection:bg-blue-500/10">
        
        {/* 1. Main Allergen Review Module Page Header */}
        <section className="w-full">
            <AllergenHeader />
        </section>

        {/* 2. Structured Dual Grid Workspace Layout */}
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
            
            {/* LEFT MAIN AUDITING PANEL (Spans 8/12 Columns) */}
            <main className="xl:col-span-8 space-y-6 w-full min-w-0">
            {/* Main Interactive Checklist Matrix */}
            <AllergenChecklist />
            
            {/* Final Submission Notes and Verification Stamp */}
            <AllergenSignOff />
            </main>

            {/* RIGHT SIDEBAR METRICS & INFO PANEL (Spans 4/12 Columns) */}
            <aside className="xl:col-span-4 flex flex-col sm:flex-row xl:flex-col gap-6 w-full items-start justify-start xl:justify-items-stretch">
            {/* Real-Time Progress Circle Tracker */}
            <div className="w-full sm:w-auto xl:w-full flex-shrink-0">
                <CheckProgress passed={12} issues={1} pending={15} />
            </div>

            {/* Compliance Records Preview Ledger */}
            <div className="w-full sm:w-auto xl:w-full flex-shrink-0">
                <ComplianceRecords />
            </div>

            {/* Legal Guidance Context & Incident Logs Alert Cards Box */}
            <div className="w-full sm:w-auto xl:w-full flex-shrink-0">
                <GuidanceAndImportantCards />
            </div>
            </aside>
        </div>
        </div>
    </DefaultLayout>
  );
}

export default MonthlyAlerginCheckPage;
